export enum CrmCenterType {    
    ProspectCenter = 1,
    MemberCenter = 2
}